import React from 'react';
import styled from '@emotion/styled';
import MainTable from './MainTable';
import Button from '../../common/Button';

const Wrapper = styled('div')`
  background: #ffffff;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.1);
  border-radius: 3px;
  padding: 24px;
  max-width: 1158px;
  width: 100%;
  color: #6e768e;
  @media (max-width: 540px) {
    padding: 15px;
  }
  .fixed-table-container {
    overflow-x: auto;
  }
  h5 {
    font-size: 14px;
    font-weight: 500;
  }
  .title {
    font-size: 14px;
    color: #6e768e;
    font-weight: 500;
    text-transform: uppercase;
  }
  div {
    color: #6e768e;
    font-size: 14px;
    line-height: 20px;
  }
  .bolder {
    font-weight: 500;
    font-size: 14px;
  }
`;

const MainBlock = ({ item }) => {
  return (
    <Wrapper>
      <div className="row d-flex justify-content-end">
        <div className="col-md-3 col-5 d-flex justify-content-md-end">
          {/*<Button*/}
          {/*  classType="btn-light"*/}
          {/*  icon="fe-arrow-down"*/}
          {/*  text="Скачать документ"*/}
          {/*  onClick={() => false}*/}
          {/*></Button>*/}
        </div>
      </div>
      {item && <MainTable item={item} />}
    </Wrapper>
  );
};

export default MainBlock;
